import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useGetOrderByOrderIdAndTypeQuery } from "../../ordersApi";
import TaxDetailTabSection from "./TaxDetailTabSection";
import {useDispatch} from "react-redux";
import {setShowSidebar} from "../../../../app/globalSlice/globalSlice";

const TaxEditor: FC = () => {

    let { orderId } = useParams();
    const [crumbs, setCrumbs] = useState<any[]>([])

    const orderQuery = useGetOrderByOrderIdAndTypeQuery({ orderId: orderId, orderType: 'OTHER' });

    document.title = `${orderQuery?.data?.customerOrderNumber} Tax Editor`;

    useEffect(() => {
        if (orderQuery?.data) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Orders", url: "/orders" },
                { content: orderQuery?.data?.customerOrderNumber, url: "/orders/" + orderId },
                { content: "Tax Certificate Editor", url: "" }
            ])
        }
    }, [orderQuery?.data]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setShowSidebar(true));
    }, []);

    return (
        <>
            {orderQuery?.data &&
                <div className="px-5 py-5">
                    <Breadcrumb crumbs={crumbs} />
                    <TaxDetailTabSection />
                </div>
            }
        </>
    )

}
export default TaxEditor